import React, { Component } from 'react';

import noop from 'lodash/noop';

import Flag, { FlagGroup } from '@atlaskit/flag';

import { type FireClickEvent } from '../../common/types/analytics';
import { buttonActionTypes } from '../../common/types/button';
import HtmlContent from '../../controllers/utils/html-content';

import allowedIcons, { type FlagIcons } from './utils/allowed-icons';

export type Action = {
	type: string;
	// we only support links at this time
	data?: {
		target: string;
		url: string;
	};
};

type Props = {
	fireClickEvent: FireClickEvent;
	title: string;
	body: string;
	primaryText: string | null;
	primaryAction: Action | null;
	secondaryText: string | null;
	secondaryAction: Action | null;
	icon: FlagIcons;
};

// eslint-disable-next-line @repo/internal/react/no-class-components
export default class EngagementFlag extends Component<Props> {
	static defaultProps = {
		fireClickEvent: noop,
		primaryText: null,
		primaryAction: null,
		secondaryText: null,
		secondaryAction: null,
		icon: 'smallInfo',
	};

	onDismiss = () => {
		this.props.fireClickEvent('dismiss');
	};

	onPrimaryClick = () => {
		const { fireClickEvent, primaryAction } = this.props;
		fireClickEvent('primary');

		this.onClickActionHandler(primaryAction);
	};

	onSecondaryClick = () => {
		const { fireClickEvent, secondaryAction } = this.props;
		fireClickEvent('secondary');

		this.onClickActionHandler(secondaryAction);
	};

	onClickActionHandler(action: Action | null) {
		if (action && action.type === buttonActionTypes.LINK && action.data) {
			window.open(action.data.url, action.data.target);
		}
	}

	render() {
		const { title, body, primaryText, secondaryText, icon } = this.props;

		const actions = [
			{
				content: primaryText,
				onClick: this.onPrimaryClick,
			},
		];

		if (secondaryText) {
			actions.push({
				content: secondaryText,
				onClick: this.onSecondaryClick,
			});
		}

		const selectedIcon = allowedIcons[icon];
		const FlagIconComponent = selectedIcon && selectedIcon.component;
		const FlagIcon = FlagIconComponent ? (
			<FlagIconComponent label={selectedIcon.label} color={selectedIcon.color} spacing="spacious" />
		) : null;

		return (
			<FlagGroup onDismissed={this.onDismiss}>
				<Flag
					id="engagement-flag"
					appearance="normal"
					icon={FlagIcon}
					title={title}
					description={<HtmlContent html={body} />}
					actions={actions}
				/>
			</FlagGroup>
		);
	}
}
